import CscartAppDrawer from 'modules/apps/apps/CscartApp/drawers/CscartAppDrawer';
import CscartConnectDrawer from 'modules/apps/apps/CscartApp/drawers/CscartConnectDrawer';

const drawers = [CscartAppDrawer, CscartConnectDrawer];

export default drawers;
